/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/esql/x-pack-esql/definition/functions/network_direction.json`.

import type { FunctionDefinition } from '../../definition_types';

/**
 * Returns the direction type (inbound, outbound, internal, external) given a source IP address, destination IP address, and a list of internal networks.
 *
 * @example
 * ROW ip0 = "127.0.0.1"::ip, ip1 = "5.6.7.8"::ip
 * | EVAL direction = NETWORK_DIRECTION(ip0, ip1, ["loopback", "private"])
 */
const definition: FunctionDefinition = {
  type: 'scalar',
  name: 'network_direction',
  signatures: [
    {
      params: [
        {
          name: 'source_ip',
          type: 'ip',
          optional: false,
        },
        {
          name: 'destination_ip',
          type: 'ip',
          optional: false,
        },
        {
          name: 'internal_networks',
          type: 'keyword',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
    {
      params: [
        {
          name: 'source_ip',
          type: 'ip',
          optional: false,
        },
        {
          name: 'destination_ip',
          type: 'ip',
          optional: false,
        },
        {
          name: 'internal_networks',
          type: 'text',
          optional: false,
        },
      ],
      variadic: false,
      returnType: 'keyword',
    },
  ],
  preview: true,
  snapshotOnly: false,
};

export default definition;
